import { render, staticRenderFns } from "./CoverPhoto.vue?vue&type=template&id=0f791c58&scoped=true&"
import script from "./CoverPhoto.vue?vue&type=script&lang=js&"
export * from "./CoverPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CoverPhoto.vue?vue&type=style&index=0&id=0f791c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f791c58",
  null
  
)

export default component.exports